export const START_SELLING_PROCESS_STEPS = [
  {
    number: '1',
    title: 'List your pieces',
    body:
      'Create an account and list your items directly: brand, size, condition, price. Minimum price is $50. No fast fashion, please.',
  },
  {
    number: '2',
    title: 'Your item goes live',
    body:
      'Listings go live automatically. When it sells, ship within 5 business days. Honest descriptions mean happy buyers and no disputes.',
  },
  {
    number: '3',
    title: 'You get paid',
    body:
      "80% lands in your bank account once the 3-day buyer window passes. Our 20% covers shipping and all payment processing. That's the only fee.",
  },
];

export const START_SELLING_FAQ_GROUPS = [
  {
    label: 'Logistics',
    items: [
      {
        question: 'How long do I have to ship?',
        answer:
          '5 business days from receiving the order. Buyers can raise a dispute within 3 business days of delivery.',
      },
      {
        question: "What's the commission?",
        answer:
          'We take 20%. That covers shipping and all payment processing. No other fees, no surprises. Your 80% hits your bank account once the 3-day dispute window closes.',
      },
      {
        question: 'Is there a minimum price?',
        answer:
          "$50 minimum. We're not a fast fashion platform and we don't want deeply damaged items. If you're listing it here, it should be something worth owning.",
      },
    ],
  },
  {
    label: 'Disputes',
    items: [
      {
        question: 'What if a buyer wants to return something?',
        answer:
          "Disputes are only valid when a seller has clearly committed fraud or completely misrepresented an item. If an item just isn't to your liking, relist it. We charge 10% on relisted items. Email hello@unvarnished.clothing with your order name and photo proof.",
      },
      {
        question: 'What counts as misrepresentation?',
        answer:
          '"I do not love it anymore" is not a dispute. A valid dispute is when an item arrives a completely different colour, different brand, or dramatically worse condition than described.',
      },
    ],
  },
  {
    label: 'Vibes',
    items: [
      {
        question: 'Is there a code of conduct?',
        answer:
          'For the love of God, please be kind and reasonable. Do not list items with period stains or that reek of cigarettes. On the other side of your transaction is a woman who has gone through all the same online shopping hassles as you.',
      },
      {
        question: 'What kinds of items are you looking for?',
        answer:
          'Contemporary and luxury brands in good condition. Think Maje, Sandro, Sezane, Isabel Marant, Chanel, Saint Laurent, and Hermes. No fast fashion, no heavily worn items.',
      },
    ],
  },
  {
    label: 'Getting Started',
    items: [
      {
        question: 'Do I need an account to sell?',
        answer:
          'You list your items directly. No approval needed. Listings go live automatically once submitted. Just make sure your description is accurate and your price is $50 or above.',
      },
      {
        question: 'Still have questions?',
        answer:
          "Email hello@unvarnished.clothing. We're real people and we answer emails. Occasionally very promptly.",
      },
    ],
  },
];

export const START_SELLING_TESTIMONIAL_COLUMNS = [
  {
    label: 'Sellers',
    featured: {
      quote: 'One item paid out more than ten RealReal sales combined.',
      name: 'Finance MD',
      role: 'Unvarnished seller',
      tag: 'Sold designer pieces',
    },
    quotes: [
      {
        quote:
          "I wasn't going to give away pieces I'd invested in for pennies on the dollar. Unvarnished was the first platform where the payout actually reflected what I'd paid.",
        attribution: 'Stylish French Mom, NYC',
        detail: 'Sold Sezane, Sandro, Ba&sh',
      },
      {
        quote:
          'Pre-kids Louboutins collecting dust: 4.5" heels that made my feet hurt just looking at them. The payout made letting them go easy.',
        attribution: 'Marketing VP',
        detail: 'Sold Louboutin heels',
      },
    ],
  },
  {
    label: 'Buyers',
    featured: {
      quote:
        "The bag showed up in even better condition than the photos suggested. 'Pristine' actually meant pristine.",
      name: 'Unvarnished buyer',
      role: 'NYC',
    },
    quotes: [
      {
        quote:
          "It's like shopping a friend's closet instead of pawing through racks at a consignment store. Everything is thoughtfully curated, not just thrown up for sale.",
        attribution: 'Unvarnished buyer',
      },
      {
        quote:
          "Found an Hermes bag for half what I'd seen on other resale sites. Same condition, significantly better price. This is what you hope exists but rarely find.",
        attribution: 'Unvarnished buyer',
      },
    ],
  },
];
